<template>
    <div v-cloak>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("rangosDeMesas")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="cambioNegocio()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.establishmentName">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t("TPV")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idTpv"
                                           filterable
                                           :placeholder="$t('seleccionaTpv')"
                                           @change="cambioTpv()">
                                    <el-option v-for="tpv in listTpv"
                                               class="select-primary"
                                               :value="tpv.id"
                                               :label="tpv.nameShow"
                                               :key="tpv.nameShow">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <div class="card">
                    <div class="row">
                        <div class="col-md-8" v-if="retail">
                            <div class="form-group">
                                <button @click="openModal()" class="btn btn-primary"><i
                                        class="fa fa-plus-square"></i>
                                    {{$t("nuevoRangoMesa")}}
                                </button>
                                <i class="fa fa-info-circle"></i>
                                <small>
                                    <router-link :to="{name:'ventas-negocios-rango-mesas'}">
                                        {{$t("verUnInformeDeRangosDeMesas")}}
                                    </router-link>
                                </small>
                            </div>
                        </div>
                    </div>

                    <div class="table-responsive" v-if="listRango.length>0 && respuesta && retail">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                            <tr>
                                <th>{{$t("nombre")}}</th>
                                <th>{{$t("mesaInicial")}}</th>
                                <th>{{$t("mesaFinal")}}</th>
                                <th width="10%">{{$t("acciones")}}</th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="rango in listRango" :key="rango.id">
                                <td>
                                    <div>{{rango.name}}</div>
                                </td>
                                <td>
                                    <div>{{rango.initTable}}</div>
                                </td>
                                <td>
                                    <div>{{rango.endTable}}</div>
                                </td>
                                <td>
                                    <div>
                                        <a @click="getRangoMesas(rango.id)" class="btn btn-danger btn-link btn-xs">
                                            <i v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt"
                                               style="color: orange"></i>
                                        </a>
                                        <a @click="modalBorrarRangoMesa(rango.id)"
                                           class="btn btn-danger btn-link btn-xs">
                                            <i v-tooltip.top-center="$i18n.t('borrarRangoMesas')"
                                               class="fas fa-trash-alt text-danger"></i>
                                        </a></div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="alert alert-danger" role="alert">
                        {{$t("noHayRangosDeMesasEnEsteTpv")}}
                    </div>
                </div>
            </div>
        </div>

        <modal name="modal-nuevo-rango-mesa" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("rangosDeMesas")}}</h4>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label for="nameMesa">{{$t("nombreRangoDeMesas")}}</label>
                        <input type="text" class="form-control"
                               v-model="name"
                               id="nameMesa">
                    </div>

                    <div class="form-group">
                        <label>{{$t("mesaInicial")}}</label>
                            <vue-numeric
                              type="text"
                              class="form-control"
                              currency-symbol-position="suffix"
                              :precision="0"
                              v-model="initTable"
                            >
                            </vue-numeric>
                    </div>
                    <div class="form-group">
                        <label>{{$t("mesaFinal")}}</label>
                             <vue-numeric
                              type="text"
                              class="form-control"
                              currency-symbol-position="suffix"
                              :precision="0"
                              v-model="endTable"
                            >
                            </vue-numeric>
                    </div>
                </div>
                <div class="modal-footer">
                    <div align="right" class="col-12">

                        <button class="btn btn-danger" @click="closeModal()"><i class="fa fa-window-close"></i>
                            {{$t("cancelar")}}
                        </button>

                        <button class="btn btn-primary" @click="saveMesa()"><i class="fa fa-check-square"></i>
                            {{$t("guardar")}}
                        </button>

                    </div>
                </div>
            </div>
        </modal>

    </div>
</template>
<script>
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        created() {
//            this.loading = Loading.service({text: 'Cargando...'});
            this.$store.dispatch("setNameRoute", this.$i18n.t("rangosDeMesas"));
            this.getBusiness();

            if (this.$store.getters.idBusiness) {
                this.idBusiness = this.$store.getters.idBusiness;
            }
            if (this.$store.getters.idTpv) {
                this.idTpv = this.$store.getters.idTpv;
            }
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: false,
                listBusinesses: [],
                listTpv: [],
                listRango: ["-"], // Pongo '-' para cuando cargue la vista no se vea el rojo de no hay elementos
                idBusiness: this.$route.params.idBusiness,
                idTpv: this.$route.params.idTpv,
                searchQuery: this.$route.params.query,
                isSearch: false,
                pag: this.$route.params.pag,
                totalPags: 0,
                respuesta: true,

                name: "",
                initTable: 1,
                endTable: 1,

                idRangoMesa: null,
                retail:true,
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.params.pag) {
                    this.pag = to.params.pag;
                    this.getRangosMesas();
                } else if (to.params.query) {
                    this.query = to.params.query;
                    this.getRangosMesas();
                }
            }
        },
        computed: {
            ...mapState(["permiso"])
        },
        methods: {
            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        if (!vm.idBusiness) {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.listBusinesses = response.data.result;
                        vm.getTpv();
                        vm.getConfigTpvRetail();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getConfigTpvRetail() {
                var config = {
                    params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    numConfig: 84,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function(response) {
                    
                    if (response.data.response) {
                      
                        vm.retail = false;
                         swal({
                          title: "Negocio tipo RETAIL",
                          text: "Esta información no esta disponible para su modelo de negocio",
                          confirmButtonClass: "btn btn-info btn-fill",
                          type: "info",
                          });
                    }else{
                      vm.retail = true;
                    }
                    })
                    .catch(function(error) {
                    console.log(error);
                    });
             },
            cambioNegocio() {

                this.pag = 1;
                this.totalPags = 0;

                this.getTpv();
                this.getConfigTpvRetail();
            },
            getTpv() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                    .then(function (response) {

                        vm.idTpv = response.data.result[0].id;

                        vm.listTpv = response.data.result;

                        vm.getRangosMesas();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            cambioTpv() {

                this.pag = 1;
                this.totalPags = 0;

                this.getRangosMesas();
            },
            getRangosMesas() {
                const controller = 'getRangosMesas';

                var config = {
                    params: {
                        pag: this.pag,
                        idBusiness: this.idBusiness,
                        idTpv: this.idTpv,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "rangosMesas/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listRango = response.data.result;
                            vm.respuesta = true;
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                            vm.respuesta = false;
                        }
//                        vm.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getRangoMesas(id) {
                this.idRangoMesa = id;

                const controller = 'getRangoMesasById';
                var config = {
                    params: {
                        pag: this.pag,
                        idBusiness: this.idBusiness,
                        idTpv: this.idTpv,
                        idRangoMesa: id,
                        jwt: this.$store.getters.jwt,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "rangosMesas/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.name = response.data.result.name;
                            vm.initTable = response.data.result.initTable;
                            vm.endTable = response.data.result.endTable;

                            vm.openModal();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                            vm.respuesta = false;
                        }
//                        vm.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            saveMesa() {

                if (this.name === '') {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('elCampoNombreEsRequerido'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {
                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idBusiness: this.idBusiness,
                        idTpv: this.idTpv,
                        name: this.name,
                        initTable: this.initTable,
                        endTable: this.endTable,
                        idRangoMesa: this.idRangoMesa,
                        jwt: this.$store.getters.jwt
                    };

                    let vm = this;
                    let controller = this.idRangoMesa ? "editRangoMesas" : "newRangoMesas";
                    this.axios.post(this.$store.getters.apiUrl + 'rangosMesas/' + controller, params, config)
                        .then(function (response) {
                            if (response.data.response) {
                                let notify = vm.idRangoMesa ? vm.$t("actualizada") : vm.$t("creada");
                                vm.$notify({
                                    message: vm.$t('rangosDeMesas') + ' ' + notify + ' '+ vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                vm.getRangosMesas();

                                vm.$modal.hide("modal-nuevo-rango-mesa");

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });

                    this.idRangoMesa = null;
                    this.name = "";
                    this.initTable = 1;
                    this.endTable = 1;
                }
            },

            closeModal() {
                this.$modal.hide("modal-nuevo-rango-mesa");
                this.idRangoMesa = null;
                this.name = "";
                this.initTable = 1;
                this.endTable = 1
            },

            openModal() {
                this.$modal.show("modal-nuevo-rango-mesa");
            },

            deleteRangoMesas(id) {

                var params = {
                    idBusiness: this.idBusiness,
                    idTpv: this.idTpv,
                    id: id,
                    jwt: this.$store.getters.jwt,
                };

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                let controller = "deleteRangoMesas";
                this.axios.post(this.$store.getters.apiUrl + 'rangosMesas/' + controller, params, config)
                    .then(function (response) {

                        if (response.data.response) {
                            vm.$notify({
                                message: vm.$t('rangosDeMesas') + ' ' + vm.$t('eliminado') + ' ' + vm.$t('correctamente'),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            vm.getRangosMesas();

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });

            },

            modalBorrarRangoMesa(id) {
                swal({
                    title: this.$t('deseaEliminarEsteRangoDeMesas'),
                    text: this.$t('estaOperacionNoSePuedeDeshacer'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    confirmButtonText: this.$t('siBorrarEsteRangoDeMesas'),
                    cancelButtonText: this.$t('cancelar'),
                    buttonsStyling: true
                }).then((result) => {
                    if (result.value) {
                        this.deleteRangoMesas(id);
                    }
                });
            }
        }
    }
</script>

<style scoped>

    [v-cloak] {
        display: none;
    }

    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
    }

    tbody td {
        padding: 0 !important;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/General/RangosMesas.vue